import { render, staticRenderFns } from "./DepartmentTargetKeyValue.vue?vue&type=template&id=c0eb4f54&scoped=true&"
import script from "./DepartmentTargetKeyValue.vue?vue&type=script&lang=js&"
export * from "./DepartmentTargetKeyValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0eb4f54",
  null
  
)

export default component.exports